import React, { Component } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import Numeral from "numeral";
import { Breadcrumb, Budget } from "../../../components";
import ImageMagnifier from "../../../components/ImageMagnifier";
import actions from "../../../redux/modules/user";
import mainActions from "../../../redux/modules/main";
import appConfig from "../../../config/app-config";
import "numeral/locales/pt-br";
import {
  getByDmService,
  insertDmService,
  getDmService
} from "../../../services/Api";

class ProductDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imagem: "",
      quantidadeCarrinho: 0,
      estoqueOriginal: 0,
      subTotalCurrent: 0
    };
  }

  async componentWillMount() {
    const { match } = this.props;
    Numeral.locale("pt-br");
    await this.getItem(match.params.id);
    await this.getSaldoAtual();
  }

  getItem = async id => {
    try {
      const produto = await getByDmService("/Produto", id);

      const valor = produto.preco * produto.quantidadeCarrinho;
      const estoqueOriginal = produto.estoque;
      let { estoque } = produto;

      if (valor > 0) {
        estoque = produto.estoque - produto.quantidadeCarrinho;
      }

      const imagem =
        produto.fotos && produto.fotos.length > 0
          ? produto.fotos[0].caminho
          : "";

      this.setState({
        ...produto,
        estoque,
        estoqueOriginal,
        qtdCartOriginal: produto.quantidadeCarrinho
      });

      setTimeout(() => {
        this.setState({ imagem: `${imagem}?id=0` });
      }, 500);
    } catch (ex) {
      toast.error("Ocorreu uma falha ao processar a requisição");
    }
  };

  getSaldoAtual = async () => {
    try {
      const data = await getDmService("/Orcamento/SaldoAtual");
      const { saldoAtual } = data;
      this.setState({
        saldoAtual
      });
    } catch (error) {
      console.log(error);
    }
  };

  onQtdChange = event => {
    const { estoqueOriginal, preco, qtdCartOriginal } = this.state;
    const val = event.target.value;
    const estoqueNovo = estoqueOriginal - val;
    const valueCalc = val - qtdCartOriginal;
    let qtd = val;
    let _estoque = estoqueNovo;

    if (!(val >= 0 && estoqueNovo >= 0)) {
      if (val >= 0) {
        qtd = estoqueOriginal;
        _estoque = 0;
      } else {
        qtd = 0;
        _estoque = estoqueOriginal;
      }
    }
    const subTotalCurrent = preco * valueCalc;
    const limitedEstoque = val <= estoqueOriginal;
    if (qtd >= 0 && limitedEstoque) {
      this.setState({
        quantidadeCarrinho: qtd,
        estoque: _estoque,
        subTotalCurrent
      });
    }
  };

  onChangeButtonQuantity = event => {

    const {
      quantidadeCarrinho,
      preco,
      estoqueOriginal,
      qtdCartOriginal
    } = this.state;
    let quantityCurrent = parseInt(quantidadeCarrinho, 10) + event;
    const qtdIsNan = Number.isNaN(quantityCurrent)
    if(qtdIsNan){
      quantityCurrent = 0;
    }
        
    const valueCalc = quantityCurrent - qtdCartOriginal;
    const subTotalCurrent = preco * valueCalc;
    const estoqueNovo = estoqueOriginal - quantityCurrent;
    let qtd = quantityCurrent;
    let _estoque = estoqueNovo;

    if (!(qtd >= 0 && estoqueNovo >= 0)) {
      if (qtd >= 0) {
        qtd = estoqueOriginal;
        _estoque = 0;
      } else {
        qtd = 0;
        _estoque = estoqueOriginal;
      }
    }

    const limitedEstoque = quantityCurrent <= estoqueOriginal;
    if (quantityCurrent >= 0 && limitedEstoque) {
      this.setState({
        quantidadeCarrinho: quantityCurrent,
        subTotalCurrent,
        estoque: _estoque
      });
    }
  };

  addToCart = () => {
    const { match } = this.props;
    const { quantidadeCarrinho } = this.state;
    insertDmService("Pedido/AdicionaProdutoCarrinho", {
      IdProduto: match.params.id,
      Quantidade: quantidadeCarrinho
    })
      .then(() => {
        const { loadUser, loadCounters, history } = this.props;
        toast.success("Item adicionado com sucesso ao carrinho");
        loadUser();
        loadCounters();
        history.goBack();
      })
      .catch(() => {
        toast.error("Ocorreu uma falha ao adicionar ao carrinho");
      });
  };

  setImagem = img => {
    this.setState({ imagem: img });
  };

  renderThumbs() {
    const { fotos } = this.state;
    return (
      fotos &&
      fotos.map(img => (
        <div key={img.id} className="pointer">
          <img
            onClick={() => this.setImagem(img.caminho)}
            className="img-responsive img-galery"
            alt="thumbnail"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
            style={{
              backgroundImage: `url('${appConfig.IMAGE_PATH + img.caminho}')`
            }}
          />
        </div>
      ))
    );
  }

  render() {
    const {
      nome,
      produtoCategoria,
      descricao,
      estoque,
      imagem,
      preco,
      quantidadeCarrinho,
      qtdCartOriginal,
      estoqueOriginal,
      saldoAtual,
      subTotalCurrent
    } = this.state;
    const { history } = this.props;
    const disableAddCart =
      subTotalCurrent >= saldoAtual || quantidadeCarrinho === 0;

    return (
      <div className="gift-detail">
        <Breadcrumb
          title="Brindes"
          description="Descrição"
          renderRight={
            <Budget
              {...this.props}
              subTotalCurrent={subTotalCurrent}
              saldoAtual={saldoAtual}
            />
          }
          renderLeft={(() => (
            <div
              className="breadcrumb-left-actions pointer"
              onClick={() => history.goBack()}
            >
              <svg width="16" height="14" viewBox="0 0 16 14">
                <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
              </svg>
            </div>
          ))()}
        />
        <div className="content-wrapper--large">
          <div className="row-product-detail">
            <div className="gallery-product-detail">
              <div className="image-magnifier__wrapper">
                <ImageMagnifier
                  smallImage={{
                    src: appConfig.IMAGE_PATH + imagem
                  }}
                  largeImage={{
                    src: appConfig.IMAGE_PATH + imagem
                  }}
                />
              </div>
              <div className="image-thumbs-box" style={{ overflow: "auto" }}>
                {this.renderThumbs()}
              </div>
            </div>
            <div className="description-breadcrumb">
              <div className="description-breadcrumb__wrapper">
                <a
                  className="link-thumb pointer"
                  onClick={() => history.goBack()}
                >
                  {(produtoCategoria || { NOME: "" }).nome}
                </a>
                <p className="title-thumb">{nome}</p>
                <p className="product-desc">{descricao}</p>
                <p className="price-thumb">{Numeral(preco).format("$ 0.00")}</p>
                <div className="quantity-thumb mg-top-30">
                  <strong>Quantidade</strong>
                  <br />
                  <button
                    type="button"
                    className="product-desc-qtd-button"
                    onClick={() => this.onChangeButtonQuantity(-1)}
                  >
                    -
                  </button>
                  <input
                    type="text"
                    className="product-desc-qtd-input number-input "
                    name="quantidadeCarrinho"
                    id="tj-input"
                    step={1}
                    min={0}
                    max={estoqueOriginal}
                    value={quantidadeCarrinho}
                    onChange={this.onQtdChange}
                  />
                  <button
                    type="button"
                    className="product-desc-qtd-button"
                    onClick={() => this.onChangeButtonQuantity(1)}
                  >
                    +
                  </button>
                </div>
                <div className="clearfix" />
                <div className="quantity-thumb mg-top-10 crear-fix">
                  <label>
                    {estoque}
                    {" em estoque"}
                  </label>
                </div>
                <div className="clearfix" />
              </div>
              {quantidadeCarrinho >= qtdCartOriginal ? (
                <button
                  className="bx--btn btn-secondary-color btn-lg opcity add-to-cart"
                  onClick={this.addToCart}
                  disabled={disableAddCart}
                  type="button"
                >
                  Adicionar ao carrinho{" "}
                  {subTotalCurrent > 0 &&
                    Numeral(subTotalCurrent).format("$ 0.00")}
                </button>
              ) : (
                <button
                  className="bx--btn btn-secondary-color btn-lg opcity add-to-cart"
                  onClick={this.addToCart}
                  disabled={disableAddCart}
                  type="button"
                >
                  Atualizar carrinho{" "}
                  {subTotalCurrent > 0 &&
                    Numeral(subTotalCurrent).format("$ 0.00")}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  loadUser() {
    dispatch(actions.receiveUserData());
  },
  loadCounters() {
    return dispatch(mainActions.receiveCounters());
  }
});

const mapStateToProps = state => ({
  user: state.user.data
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductDetails);



// WEBPACK FOOTER //
// ./src/screens/client/agency/ProductDetails.jsx